"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.EventDispatcher = exports.ExceptionEvent = exports.NetworkQualityLevelChangedEvent = exports.FilterEvent = exports.ConnectionPropertyChangedEvent = exports.StreamPropertyChangedEvent = exports.VideoElementEvent = exports.StreamManagerEvent = exports.StreamEvent = exports.SignalEvent = exports.SessionDisconnectedEvent = exports.RecordingEvent = exports.PublisherSpeakingEvent = exports.ConnectionEvent = exports.Event = exports.VideoInsertMode = exports.OpenViduError = exports.LocalRecorderState = exports.Filter = exports.LocalRecorder = exports.Connection = exports.Stream = exports.StreamManager = exports.Subscriber = exports.Publisher = exports.Session = exports.OpenVidu = void 0;
var OpenVidu_1 = require("./OpenVidu/OpenVidu");
__createBinding(exports, OpenVidu_1, "OpenVidu");
var Session_1 = require("./OpenVidu/Session");
__createBinding(exports, Session_1, "Session");
var Publisher_1 = require("./OpenVidu/Publisher");
__createBinding(exports, Publisher_1, "Publisher");
var Subscriber_1 = require("./OpenVidu/Subscriber");
__createBinding(exports, Subscriber_1, "Subscriber");
var StreamManager_1 = require("./OpenVidu/StreamManager");
__createBinding(exports, StreamManager_1, "StreamManager");
var Stream_1 = require("./OpenVidu/Stream");
__createBinding(exports, Stream_1, "Stream");
var Connection_1 = require("./OpenVidu/Connection");
__createBinding(exports, Connection_1, "Connection");
var LocalRecorder_1 = require("./OpenVidu/LocalRecorder");
__createBinding(exports, LocalRecorder_1, "LocalRecorder");
var Filter_1 = require("./OpenVidu/Filter");
__createBinding(exports, Filter_1, "Filter");
var LocalRecorderState_1 = require("./OpenViduInternal/Enums/LocalRecorderState");
__createBinding(exports, LocalRecorderState_1, "LocalRecorderState");
var OpenViduError_1 = require("./OpenViduInternal/Enums/OpenViduError");
__createBinding(exports, OpenViduError_1, "OpenViduError");
var VideoInsertMode_1 = require("./OpenViduInternal/Enums/VideoInsertMode");
__createBinding(exports, VideoInsertMode_1, "VideoInsertMode");
var Event_1 = require("./OpenViduInternal/Events/Event");
__createBinding(exports, Event_1, "Event");
var ConnectionEvent_1 = require("./OpenViduInternal/Events/ConnectionEvent");
__createBinding(exports, ConnectionEvent_1, "ConnectionEvent");
var PublisherSpeakingEvent_1 = require("./OpenViduInternal/Events/PublisherSpeakingEvent");
__createBinding(exports, PublisherSpeakingEvent_1, "PublisherSpeakingEvent");
var RecordingEvent_1 = require("./OpenViduInternal/Events/RecordingEvent");
__createBinding(exports, RecordingEvent_1, "RecordingEvent");
var SessionDisconnectedEvent_1 = require("./OpenViduInternal/Events/SessionDisconnectedEvent");
__createBinding(exports, SessionDisconnectedEvent_1, "SessionDisconnectedEvent");
var SignalEvent_1 = require("./OpenViduInternal/Events/SignalEvent");
__createBinding(exports, SignalEvent_1, "SignalEvent");
var StreamEvent_1 = require("./OpenViduInternal/Events/StreamEvent");
__createBinding(exports, StreamEvent_1, "StreamEvent");
var StreamManagerEvent_1 = require("./OpenViduInternal/Events/StreamManagerEvent");
__createBinding(exports, StreamManagerEvent_1, "StreamManagerEvent");
var VideoElementEvent_1 = require("./OpenViduInternal/Events/VideoElementEvent");
__createBinding(exports, VideoElementEvent_1, "VideoElementEvent");
var StreamPropertyChangedEvent_1 = require("./OpenViduInternal/Events/StreamPropertyChangedEvent");
__createBinding(exports, StreamPropertyChangedEvent_1, "StreamPropertyChangedEvent");
var ConnectionPropertyChangedEvent_1 = require("./OpenViduInternal/Events/ConnectionPropertyChangedEvent");
__createBinding(exports, ConnectionPropertyChangedEvent_1, "ConnectionPropertyChangedEvent");
var FilterEvent_1 = require("./OpenViduInternal/Events/FilterEvent");
__createBinding(exports, FilterEvent_1, "FilterEvent");
var NetworkQualityLevelChangedEvent_1 = require("./OpenViduInternal/Events/NetworkQualityLevelChangedEvent");
__createBinding(exports, NetworkQualityLevelChangedEvent_1, "NetworkQualityLevelChangedEvent");
var ExceptionEvent_1 = require("./OpenViduInternal/Events/ExceptionEvent");
__createBinding(exports, ExceptionEvent_1, "ExceptionEvent");
var EventDispatcher_1 = require("./OpenVidu/EventDispatcher");
__createBinding(exports, EventDispatcher_1, "EventDispatcher");
//# sourceMappingURL=index.js.map